<template>
    <div class="procreate-slideshow">
        <div class="procreate-slideshow__background">
            <img
                class="procreate-slideshow__background-image"
                :class="{ 'procreate-slideshow__background-image--active': i == currentItem }"
                v-for="(item, i) in items"
                :src="$asset(item.bg)"
                alt=""
            />
        </div>

        <div class="procreate-slideshow__content container">
            <div class="procreate-slideshow__ipad">
                <div class="ipad">
                    <img
                        class="procreate-slideshow__foreground-image"
                        :class="{ 'procreate-slideshow__foreground-image--active': i == currentItem }"
                        v-for="(item, i) in items"
                        :src="$asset(item.image)"
                        alt=""
                        width="1734"
                        height="1300"
                    />
                </div>
            </div>

            <slot />
        </div>
    </div>
</template>

<script>
const delaySeconds = 4;

export default {
    props: {
        items: Array,
    },

    data: () => ({
        currentItem: 0,
        interval: null,
    }),

    mounted() {
        this.interval = setInterval(() => {
            this.currentItem++;
            if (this.currentItem >= this.items.length) this.currentItem = 0;
        }, delaySeconds * 1000);
    },

    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>
